<script setup lang="ts">

import skeletonRow from './skeletonRow.vue';
const props = defineProps(["width", "rows"])

</script>

<template>
    <table class="alt-table w-full">
    <tr v-for="(item, index) in props.rows" :key="index">
        <td class="mr-auto !pt-4 text-center">
            <skeleton-row :width="props.width" />
        </td>
    </tr>
</table>
</template>

<style scoped>
    
    table,
    tr{
        box-shadow: none !important;
        border:none !important;
    }

</style>